import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ModalMode, ROLE_READ_ONLY } from '../../../stores/Administrators/AdministratorModalStore';
import EnvStore from '../../../stores/EnvStore';
import PolicyStore from '../../../stores/Policy/PolicyStore';
import ConsoleStore from '../../../stores/ConsoleStore';
import FuseReadOnlyTextfield from '../../FuseControls/FuseReadOnlyTextfield';
import FuseReadOnlySwitch from '../../FuseControls/FuseReadOnlySwitch';
import MatchCriteria from '../MatchCriteria';
import PolicyModal from '../PolicyModal';
import PolicyModalHeaderLayout from '../PolicyModalHeaderLayout';
import Action from './ContentRulesAction';
import PageRestrictions from './PageRestrictions';
import ContentRuleName from './ContentRuleName';
import './ContentRulesModal.css';

class ContentRulesModal extends Component {
    static propTypes = {
        policy: PolicyStore.PropType.isRequired,
        env: EnvStore.PropType.isRequired,
        console: ConsoleStore.PropType,
    };

    renderHeader = () => {
        const { env, policy } = this.props;
        const { policyModal } = policy.contentRules.policyTable;

        const store = policyModal.header;
        const readOnly = [ModalMode.VIEW, ModalMode.DELETE].includes(policyModal.mode) || store.isDefault;
        const footer = store.isDefault
            ? 'The Default Content Rule is system generated and cannot be deleted, renamed or disabled.'
            : undefined;

        return <PolicyModalHeaderLayout
            title="Summary"
            readOnly={readOnly}
            footer={footer}
        >
            <FuseReadOnlyTextfield
                label="Name"
                store={store.name}
                readOnlyValue={<ContentRuleName isDefault={store.isDefault} name={store.name.value} />}
                placeholder="Enter rule name"
                error={!store.name.isValid && store.name.isTouched}
                onBlur={store.onNameFieldFocusChange}
                showRequired={!readOnly}
                required={!readOnly}
                qa="name-input"
            />

            <FuseReadOnlyTextfield
                label="Description"
                store={store.description}
                readOnlyValue={store.description.value && store.description.value.trim() || '—'}
                placeholder="Enter rule description"
                qa="description-input"
            />

            <FuseReadOnlySwitch
                header="Rule Status"
                tooltip="The status will determine if the Rule is available to live users or not."
                tooltipProps={env.screen.isMobile || readOnly ? { position: 'right' } : {}}
                store={store.status}
                label={store.status.isTrue ? 'Enabled' : 'Disabled'}
                qa="status-switch"
            />
        </PolicyModalHeaderLayout>;
    };

    constructor(props) {
        super(props);
        const { policy, console } = this.props;
        const { policyModal } = policy.contentRules.policyTable;
        policyModal.sections.matchCriteria.setFilterChannelsFunc(console.filterIsolationChannelBasedOnLicense);
    }

    render() {
        const { policyModal } = this.props.policy.contentRules.policyTable;
        const { console } = this.props;
        const {
            action,
            matchCriteria,
            pageRestrictions,
            categories
        } = policyModal.sections;
        const readOnly = [ModalMode.VIEW, ModalMode.DELETE].indexOf(policyModal.mode) > -1 ||
            console.authority === ROLE_READ_ONLY.value;
        const hasBrowserIso = console.hasBrowserOrEmailLicense();
        const hasBrowserIsoWithUrlFlagOrTap = (hasBrowserIso && console.urlIsolationProductEnabled)
            || console.hasTapUrlIsolationLicense();

        return <PolicyModal
            titleItemName="Content Rule"
            readOnly={console.authority === ROLE_READ_ONLY.value}
            store={policyModal}
        >
            {this.renderHeader()}

            <MatchCriteria
                store={matchCriteria}
                categoriesStore={categories}
                readOnly={policyModal.getValue().isDefault || readOnly}
            />
            <Action store={action} readOnly={readOnly} />
            {action.getValue().action === 'ALLOW'
                ? <PageRestrictions
                    store={pageRestrictions}
                    readOnly={readOnly}
                    urlIsolation={matchCriteria.isUrlIsolationActive()}
                    showExitIsoOption={hasBrowserIsoWithUrlFlagOrTap}
                    hasUploadDownload={console.licenseHasUploadDownload()}
                    showDLP={console.showDLPOptions()}
                    useFileThreatRules={console.isFTREnabled()}
                /> : null}
        </PolicyModal>;
    }
}

export default inject('env', 'policy', 'console')(observer(ContentRulesModal));
